export default "__VITE_ASSET__7fb3f7bd__"